// (A) 중립 Col API — antd 미접촉. (B) PlainCol 에 위임.
import type { CSSProperties, MouseEvent, ReactNode } from 'react'
import { PlainCol } from '../_impl/PlainCol'

export interface OmwColProps {
  /** 실측: calendar 가 span={24} 사용. 그 외는 flex 를 style 로 지정. */
  span?: number
  className?: string
  style?: CSSProperties
  /** 실측: calendar sidebar mask 가 클릭 핸들러 사용. */
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  children?: ReactNode
  'data-testid'?: string
}

export function OmwCol(props: OmwColProps) {
  return <PlainCol {...props} />
}
